// fonts.js
import { Font } from '@react-pdf/renderer';

// Register custom fonts
// Font.register({
//   family: 'Open Sans',
//   fonts: [
//     { src: 'https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFVZ0e.ttf' }, // Regular
//     // { src: 'https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UNirkOX-hpKKSTj5PW.ttf', fontWeight: 'bold' }, // Bold
//     { src: 'https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFWZ0e.ttf', fontWeight: 300 }, // Light

//   ],
// });

// Register Roboto fonts
Font.register({
  family: 'Roboto',
  fonts: [
    { src: 'https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxP.ttf' }, // Regular
    { src: 'https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xIIzc.ttf', fontWeight: 'bold' }, // Bold
    { src: 'https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc4AMP6lQ.ttf', fontWeight: 300 }, // Light
  ],
});



// Register Roboto fonts
Font.register({
  family: 'Open Sans',
  fonts: [
    { src: `${process.env.PUBLIC_URL}/fonts/OpenSans-Bold.ttf`}, // Regular
    { src: `${process.env.PUBLIC_URL}/fonts/OpenSans-Light.ttf`}, // Bold
    { src: `${process.env.PUBLIC_URL}/fonts/OpenSans-SemiBold.ttf`}, // Light
    { src: `${process.env.PUBLIC_URL}/fonts/OpenSans-Medium.ttf`},
  ],
});

export default Font;
